import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"

const api = new APIClient();

export const getList = (params?: any) => api.get(url.GET_WORKFLOW, params);
export const getDetail = (id: string) => api.get(`${url.GET_WORKFLOW}/${id}`, null);
export const getActivities = () => api.get(url.ACTIVITIES, null);
export const add = (payload: any) => api.create(url.ADD_WORKFLOW, payload)
export const remove = (id: string) => api.delete(`${url.DELETE_WORKFLOW}/${id}`, {})
export const execute = (payload: any) => api.create(url.EXECUTE_WORKFLOW, payload)
export const update = (id: string, payload: any) => api.put(`${url.GET_WORKFLOW}/${id}`, payload)
